
export enum LayoutTypes {
  Pure = 'pure', // 无
  Default = 'default', // header 
  WithSidebar = 'withoutSidebar', // header + sidebar
  H5 = 'h5' // 针对移动端直播h5页面
}
